var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"is-size-2 has-text-centered"},[_vm._v("403 - Forbidden")])])])
}]

export { render, staticRenderFns }